// NOTE: As a result of the navbar refresh, the dataset navbar provider
// no longer tracks the visual state of any navbars, although it does
// track your current view and handle library/upload modal behavior.
// Perhaps a rename is in order?
import { Injectable } from '@angular/core';

export enum DatasetNavLocation {
    DatasetDashboard,
    ImageLibrary,
    Workspace,
    DetectionTraining,
    EvaluateBrain,
    TestBrain,
    DeployBrain,
    ExportWhiteLabelBrain,
    None
}

@Injectable()
export class DatasetNavBarProvider {
    private activePage: DatasetNavLocation;
    private onLibraryModalDismiss: Function = () => {};
    private onUploadModalDismiss: Function = () => {};

    constructor() {}

    public setLibraryModalDismissCallback(callback: Function): void {
        this.onLibraryModalDismiss = callback;
    }

    public setUploadModalDismissCallback(callback: Function): void {
        this.onUploadModalDismiss = callback;
    }

    public getLibraryModalDismissCallback(): Function {
        return this.onLibraryModalDismiss;
    }

    public getUploadModalDismissCallback(): Function {
        return this.onUploadModalDismiss;
    }

    public setActivePage(page: DatasetNavLocation): void {
        this.activePage = page;
    }

    public getActivePage(): DatasetNavLocation {
        return this.activePage;
    }
}



// WEBPACK FOOTER //
// ./src/providers/dataset_navbar.ts